import React from "react";
import OrganizationSummary from "./OrganizationSummary";

export const OrganizationOverview = () => {
  return <OrganizationSummary />;
};
